export const en = {
    'choose-campaign-type': 'Choose campaign type'
};
